import type { Prisma } from "@prisma/client";

import { RequestContext } from "~/utils/types/trpc";

export enum BlockerStatus {
  INCOMPLETE = "INCOMPLETE",
  COMPLETE = "COMPLETE",
}

export type BlockerMessage = {
  display: string;
  url?: string;
};

export type FunctionResponseEntry = { status: BlockerStatus; messages?: BlockerMessage[] };
export type FunctionResponseRecord = Record<string, FunctionResponseEntry>;

export type RunnerResponseEntry = { status: BlockerStatus; messages: BlockerMessage[] };
export type RunnerResponseRecord = Record<string, RunnerResponseEntry>;

export type BlockerItemResponseEntry = { title: string } & RunnerResponseEntry;

export type BlockerResponseEntry = {
  status: BlockerStatus.COMPLETE | BlockerStatus.INCOMPLETE;
  items: BlockerItemResponseEntry[];
  completed: number;
  total: number;
};
export type BlockerResponseRecord = Record<string, BlockerResponseEntry>;

export type BlockerCheck<T> = (ctx: RequestContext & { txn?: Prisma.TransactionClient }, items: T[]) => Promise<FunctionResponseRecord>;

export type RunnerResponse = {
  title: string;
  responses: RunnerResponseRecord;
};

export type BlockerResponseNoEntriesType = {
  enabledBlockers: false;
};

export type BlockerResponseEntriesType = {
  enabledBlockers: true;
  entries: BlockerResponseRecord;
};

export type BlockerResponseType = BlockerResponseNoEntriesType | BlockerResponseEntriesType;

export const BlockerResponseNoEntries: BlockerResponseType = { enabledBlockers: false };
